import React, { useState, useRef, useEffect } from "react";
import "../../styles/atoms/menu-button.css";

interface MenuButtonProps {
  menuItems: Array<{
    label: string;
    onClick: () => void;
    danger?: boolean;
  }>;
  className?: string;
}

const MenuButton: React.FC<MenuButtonProps> = ({ menuItems, className = "" }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div className={`menu-button ${className}`} ref={menuRef}>
      <button
        aria-haspopup="menu"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((prev) => !prev)}
        className="menu-button__trigger"
      >
        ⋯
      </button>
      <div
        className={`menu-button__dropdown ${
          menuOpen ? "menu-button__dropdown--open" : ""
        }`}
      >
        {menuItems.map((item, index) => (
          <button
            key={index}
            type="button"
            className={`menu-button__dropdown-item ${item.danger ? 'menu-button__dropdown-item--danger' : ''}`}
            onClick={() => {
              setMenuOpen(false);
              item.onClick();
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MenuButton;


